import script from "./StageIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./StageIcon.vue?vue&type=script&setup=true&lang=js"

import "./StageIcon.vue?vue&type=style&index=0&id=36f372ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36f372ad"]])

export default __exports__